import { RouteObject } from '@suntex.core/nav';
import { flaggedItems, getFlags } from '@suntex.fim/flags';

import { Games } from './pages/Games';
import { Gyms } from './pages/Gyms';
import { KnowAndShow } from './pages/KnowAndShow';
import { SkillSets } from './pages/SkillSets';
import { VIF } from './pages/VIF';
import { WDYK } from './pages/WDYK';

export interface ModuleRouteOptions {
  /** Additional routes appended after built-in module routes, acting as fallbacks. */
  additionalRoutes?: RouteObject[];
}

const builtInRoutes: RouteObject[] = [
  {
    path: 'games',
    children: [
      {
        path: 'fraction-wheels',
        element: <Games moduleSlug="fraction-wheels" />,
      },
      { path: 'k2-undo', element: <Games moduleSlug="k2-undo" /> },
    ],
  },
  { path: 'gym/:mode/:op/:game', Component: Gyms },
  ...flaggedItems(getFlags().modules.new.skillSets, [
    { path: 'ss/:level/:game', Component: SkillSets },
  ]),
  { path: 'vif/:op', Component: VIF },
  { path: 'vif/:op/:stage', Component: VIF },
  { path: 'wdyk/:secureLink', Component: WDYK },
  { path: 'wdyk2/:secureLink', Component: WDYK }, // backward compatible route
  { path: 'word-problems/:level/:category', Component: KnowAndShow },
];

/**
 * Returns the child RouteObject[] for the `/modules` route.
 *
 * Built-in routes cover gyms, wdyk, and word-problems with preview variants.
 * Pass `additionalRoutes` to register extra paths (e.g. legacy module fallbacks)
 * that will be appended in fallback position after the built-in routes.
 *
 * Preview variants are mounted by the app under `/preview/modules/{type}/...`
 * (e.g. `/preview/modules/gym/num/add/1`).
 *
 * Usage:
 * ```tsx
 * // apps.web.firstinmath
 * { path: '/modules', Component: PlayerLayout, children: createModuleRoutes() }
 *
 * // Suntex-Frontend (with legacy fallback)
 * { path: '/modules', Component: PlayerLayout, children: createModuleRoutes({ additionalRoutes: [{ path: '*', Component: Module }] }) }
 * ```
 */
export function createModuleRoutes(
  options?: ModuleRouteOptions,
): RouteObject[] {
  const additional = options?.additionalRoutes ?? [];
  return [...builtInRoutes, ...additional];
}
